import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import styles from './App.module.css'; // Pour les styles spécifiques à App

// Import des pages
import Home from './pages/Home';
import Services from './pages/Services';
import Realisations from './pages/Realisations';
import ProjectDetail from './pages/ProjectDetail';
import QuiSommesNous from './pages/QuiSommesNous';
import NotreCooperative from './pages/NotreCooperative';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import MentionsLegales from './pages/MentionsLegales';
import Recrutement from './pages/Recrutement';
import AccountPage from './pages/Account';
import DashboardLayout from './pages/DashboardLayout';
import Overview from './pages/dashboard/Overview';
import Projects from './pages/dashboard/Projects';
import Messages from './pages/dashboard/Messages';
import Reviews from './pages/dashboard/Reviews';
import Users from './pages/dashboard/Users';
import Team from './pages/dashboard/Team';
import Chantiers from './pages/dashboard/Chantiers';
import Customers from './pages/dashboard/Customers';
import Inventory from './pages/dashboard/Inventory';
import Timesheets from './pages/dashboard/Timesheets';
import Planning from './pages/dashboard/Planning';
import Documents from './pages/dashboard/Documents';
import ApplicationManagement from './components/dashboard/ApplicationManagement';
import AdminMap from './pages/dashboard/AdminMap';
import HeroSlides from './pages/dashboard/HeroSlides';
import ClientAccess from './pages/ClientAccess';

// Import des composants communs
import Navbar from './components/common/Navbar/Navbar';
import Footer from './components/common/Footer/Footer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ScrollToTopOnNavigate from './components/common/ScrollToTopOnNavigate/ScrollToTopOnNavigate'; // Import du nouveau composant
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import AuthModal from './components/common/AuthModal/AuthModal';
import SplashScreen from './components/common/SplashScreen/SplashScreen';
import { Navigate } from 'react-router-dom';

const AppContent = () => {

  const location = useLocation();
  const hideNavbarAndFooter = location.pathname.startsWith('/admin') || location.pathname.startsWith('/account');

  return (
    <div className={styles.app}>
      {!hideNavbarAndFooter && <Navbar />} {/* La barre de navigation est masquée sur le dashboard */}
      <AuthModal />
      <main className={styles.content}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/realisations" element={<Realisations />} />
          <Route path="/realisations/:slug" element={<ProjectDetail />} />
          <Route path="/qui-sommes-nous" element={<QuiSommesNous />} />
          <Route path="/notre-cooperative" element={<NotreCooperative />} />
          <Route path="/recrutement" element={<Recrutement />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/admin" element={<DashboardLayout />}>
            <Route index element={<Overview />} />
            <Route path="projects" element={<Projects />} />
            <Route path="messages" element={<Messages />} />
            <Route path="reviews" element={<Reviews />} />
            <Route path="users" element={<Users />} />
            <Route path="team" element={<Team />} />
            <Route path="recrutement" element={<ApplicationManagement />} />

            {/* Nouvelles routes ERP */}
            <Route path="planning" element={<Planning />} />
            <Route path="documents" element={<Documents />} />
            <Route path="chantiers" element={<Chantiers />} />
            <Route path="customers" element={<Customers />} />
            <Route path="inventory" element={<Inventory />} />
            <Route path="timesheets" element={<Timesheets />} />
            <Route path="map" element={<AdminMap />} />
            <Route path="website" element={<HeroSlides />} />
          </Route>
          <Route path="/access/:id/:token" element={<ClientAccess />} />
          <Route path="*" element={<NotFound />} /> {/* Route pour les pages non trouvées (404) */}
        </Routes>
      </main>
      {!hideNavbarAndFooter && <Footer />}

      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
};

function App() {
  const [showSplash, setShowSplash] = useState(true);

  // You can check sessionStorage here logic to run it only once per tab session if desired, 
  // but running it on standard mount is great for the "wow" effect on every hard reload!
  useEffect(() => {
    const hasSeenSplash = sessionStorage.getItem('hasSeenSplash');
    if (hasSeenSplash) {
      setShowSplash(false);
    }
  }, []);

  const handleSplashComplete = () => {
    setShowSplash(false);
    sessionStorage.setItem('hasSeenSplash', 'true');
  };

  return (
    <ThemeProvider>
      <AuthProvider>
        {showSplash && <SplashScreen onComplete={handleSplashComplete} />}
        <div style={{ opacity: showSplash ? 0 : 1, transition: 'opacity 0.8s ease' }}>
          <Router>
            {/* Placez le composant ScrollToTopOnNavigate à l'intérieur du Router
                pour qu'il ait accès aux hooks de React Router. */}
            <ScrollToTopOnNavigate />
            <AppContent />
          </Router>
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}


export default App;
